import { combineReducers } from "redux";
import options from "./Options/Reducers/optionsReducers";
import equity from "./Equity/Reducers/equityReducer";
import checkHolidayReducer from "./Common/Reducers/CheckHoliday";
import understandingSection from "./Common/Reducers/UnderstandSection";
import futures from "./Futures/Reducers/futuresMainReducer";
import NewOnEdel from "./Common/Reducers/NewOnEdelReducer";
import primaryMarketIPO from "./PrimaryMarket/IPO/Reducers/PrimaryMarketIPOReducer";
import primaryMarketNFO from "./PrimaryMarket/NFO/Reducers/PrimaryMarketNFOReducer";
import primaryMarketNCDIPO from "./PrimaryMarket/NCD_IPO/Reducers/PrimaryMarketNCDIPOReducer";
import MutualFunds from "./MutualFunds/Reducers/MutualFunds";
import AifPms from "./InvestmentManagement/Reducers/AifPmsReducers";
import etf from "./Etf/Reducers/ETFReducer";
import payment from "./InvestmentManagement/Reducers/PaymentReducer";
import purchase from "./InvestmentManagement/Reducers/PurchaseReducer";
import draft from "./InvestmentManagement/Reducers/DraftReducer";
import global from "./InvestmentManagement/Reducers/GlobalReducer";
import orderBook from "./InvestmentManagement/Reducers/OrderBookReducer";
import leadservice from "./InvestmentManagement/Reducers/LeadServiceReducer";
import qualityCheck from "./InvestmentManagement/Reducers/QualityCheckReducer";
import Otc from "./NCD/Reducers/Otc";
export default combineReducers({
    equity: equity,
    options: options,
    futures: futures,
    checkHolidayReducer: checkHolidayReducer,
    understandingSection: understandingSection,
    NewOnEdel: NewOnEdel,
    primaryMarketIPO: primaryMarketIPO,
    MutualFunds: MutualFunds,
    AifPms: AifPms,
    payment: payment,
    primaryMarketNFO: primaryMarketNFO,
    primaryMarketNCDIPO: primaryMarketNCDIPO,
    etf: etf,
    purchase: purchase,
    draft: draft,
    global: global,
    orderBook: orderBook,
    leadservice: leadservice,
    qualityCheck: qualityCheck,
    Otc: Otc,
});
